
export default {
  head: {
    title: 'Contador Senha Digital',
  },

  methods: {
    sendEmailJobs() {
      const enderecoEmail = 'contato@senhadigital.com.br'
      const assuntoEmail = 'Curriculo Senha Digital'

      const url = `mailto:${enderecoEmail}?subject=${encodeURIComponent(
        assuntoEmail
      )}`
      window.location.href = url
    },
    jobsOn() {
      const linkUrl = 'https://www.linkedin.com/company/senhadigitaloficial'
      window.open(linkUrl, '_blank')
    },
  },
}
